const deviceXs = state => state.window.innerWidth < 576;

const deviceSm = state => state.window.innerWidth >= 576;

const deviceMd = state => state.window.innerWidth >= 768;

const deviceLg = state => state.window.innerWidth >= 992;

const deviceXl = state => state.window.innerWidth >= 1200;

export default {
  deviceXs,
  deviceSm,
  deviceMd,
  deviceLg,
  deviceXl
};



// WEBPACK FOOTER //
// ./src/store/modules/ui/getters.js